'use client';

import React from 'react';
import { Section, Container } from '@layout';
import { t } from '@utils/translate';
import { renderTranslation } from '@utils/renderTranslation';
import { usePathname } from 'next/navigation';
import { CTABand } from '@ui';

export default function NotFound() {
  const pathname = usePathname();
  const locale = pathname.startsWith('/es') ? 'es' : 'en';
  return (
    <Section className={''}>
      <Container containerClasses=''>
        <CTABand
          headingType='h1'
          heading={(() => {
            const val = renderTranslation(t('not_found_title', 'global', locale));
            return typeof val === 'string' ? val : '';
          })()}
          description={(() => {
            const val = renderTranslation(t('not_found_description', 'global', locale));
            return typeof val === 'string' ? val : '';
          })()}
          primaryLabel={(() => {
            const val = renderTranslation(t('not_found_cta', 'global', locale));
            return typeof val === 'string' ? val : '';
          })()}
          primaryHref='/'
        />
      </Container>
    </Section>
  );
}
